import { render } from "./ProfessionCard.vue?vue&type=template&id=e96d6fd8&scoped=true"
import script from "./ProfessionCard.vue?vue&type=script&lang=js"
export * from "./ProfessionCard.vue?vue&type=script&lang=js"

import "./ProfessionCard.vue?vue&type=style&index=0&id=e96d6fd8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e96d6fd8"]])

export default __exports__